<div class="stats-summary" *ngIf="statistics.length > 0">
    <div class="stats-row-wrapper">
        <div class="stats-row" *ngFor="let row of statistics">
            <app-stats-tile *ngFor="let stats of row" 
                [color]="stats.color" 
                [value]="stats.count" 
                [label]="stats.name | translate"
                [icon]="stats.icon" 
                [description]="stats.description"
                (click)="setSelectedTile(stats.name)" 
                class="operators-tiles"
                [class.unselected-tile]="isNotActive(stats.name)"
                [class.all-unselected-tiles]="selectedTile === null">
            </app-stats-tile>
        </div>
    </div>
</div>